import Skeleton from 'src/Admin/components/common/skeleton';

const AllMemberDetailsSkeleton = () => (
  <>
    <div>
      <div className="usergrp-br">
        <div className="row">
          <div className="col-md-2">
            <Skeleton height={80} width={80} count={1} circle={true} />
          </div>
          <div className="col-md-4">
            <Skeleton count={1} width={200} height={10} />
          </div>
          <div className="col-md-6">
            <ul className="memberDetails">
              <li>
                {' '}
                <Skeleton count={1} />{' '}
              </li>
              <li>
                {' '}
                <Skeleton count={1} />{' '}
              </li>
              <li>
                {' '}
                <Skeleton count={1} />{' '}
              </li>
              <li>
                {' '}
                <Skeleton count={1} />{' '}
              </li>
            </ul>
          </div>
        </div>
        <div className="grpDivider"></div>

        <div className="memberData mt-50 row">
          <div className="col">
            <Skeleton count={1} width={200} />
          </div>
        </div>

        <div className="d-flex flex-wrap">
          <div className="col-arrange">
            <Skeleton
              count={1}
              height={140}
              width={125}
              containerClassName={'memberBox-fields'}
            />
          </div>

          <div className="col-arrange">
            <Skeleton
              count={1}
              height={140}
              width={125}
              containerClassName={'memberBox-fields'}
            />
          </div>

          <div className="col-arrange">
            <Skeleton
              count={1}
              height={140}
              width={125}
              containerClassName={'memberBox-fields'}
            />
          </div>

          <div className="col-arrange">
            <Skeleton
              count={1}
              height={140}
              width={125}
              containerClassName={'memberBox-fields'}
            />
          </div>
          <div className="col-arrange">
            <Skeleton
              count={1}
              height={140}
              width={125}
              containerClassName={'memberBox-fields'}
            />
          </div>
        </div>

        {/*<div class="memberData mt-50 row">
            <div class="col">
                <a>
                  <div class="memberBox">
                    <Skeleton count={ 1 } height={ 140 } width={ 125 } containerClassName={ 'memberBox-fields' } />
                  </div>
                </a>
            </div>
        </div> */}

        {/*<Row>
        <div class="memberBox"> <Skeleton count={ 1 } height={ 140 } width={ 125 } containerClassName={'memberBox-fields'} /></div>

          <Col
              <Skeleton count={ 1 } height={ 140 } width={ 125 } containerClassName={'memberBox-fields'} />
            </div>
          </Col>

          <Col>
              <Skeleton count={ 1 } height={ 140 } width={ 125 } containerClassName={'memberBox-fields'} />
              </div>
          </Col>

          <Col>
              <Skeleton count={ 1 } height={ 140 } width={ 125 } containerClassName={'memberBox-fields'} />
            </div>
          </Col>
        </Row> */}
      </div>
    </div>
  </>
);
export default AllMemberDetailsSkeleton;
